import snackbarListManipulation from '../factories/snackbarListManipulation'

export default snackbarListManipulation(({ props }, acc, val) => [
  ...acc,
  val.id === props.snackbar.id ? Object.assign({}, val, props.snackbar) : val
])



// WEBPACK FOOTER //
// ./src/modules/App/actions/updateSnackbar.js